import React from 'react';
import RosterMember from './RosterMember';
import {toArray} from "../common/util";

const RosterDivision = (props) => (
    <li className="roster-list-item">
        <div className="panel-roster clearfix">
            <div className="roster-division-color" style={{
                height: "100%",
                width: "5px",
                backgroundColor: `#${props.division.color}`,
                boxShadow: `0 0 40px 1px #${props.division.color}`,
            }} />
            <h4>{props.division.title}</h4>
            {
                toArray(props.chapterMembers.data)
                    .filter(member => member.division === props.division.id)
                    .filter(member=> member.leaveDate === null)
                    .sort((a, b) => (props.users[b.member].rank - props.users[a.member].rank))
                    .map((member) => {
                    if (props.users[member.member].rank !== null) {
                        return <RosterMember key={`${member.id}-member`} member={props.users[member.member]} role={member.role} ranks={props.ranks}/>
                    } else { return null}
                })
            }
        </div>
        { props.division.children.length > 0 ? (
        <ul className="roster-list">
        {
            props.division.children
                .map((division) => { return props.divisions[division] })
                .map((division) => (
                <RosterDivision
                    key={`${division.id}-division`}
                    division={division}
                    ranks={props.ranks}
                    users={props.users}
                    chapterMembers={props.chapterMembers}
                    divisions={props.divisions}
                />
            ))
        }
        </ul>
        ) : ('')
        }
    </li>
);

export default RosterDivision;


// WEBPACK FOOTER //
// ./src/Roster/RosterDivision.js